<template>
  <v-autocomplete
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    flat
    :dense="$vuetify.breakpoint.smAndDown"
    hide-no-data
    solo-inverted
    hide-selected
    hide-details
    outlined
    clearable
    :item-text="itemText"
    item-value="symbol"
    :label="$t('searchEvent')"
    return-object
    prepend-inner-icon="mdi-magnify"
    :filter="onFilter"
  >
    <!-- <template v-slot:no-data >
        <v-list-item v-show="sigla.length == 3">Nenhum evento encontrado!</v-list-item>
      </template> -->

    <template v-slot:item="{ item }">
      <v-list-item-avatar
        class="headline font-weight-light white--text"
        v-on:click="pushRoute(item)"
      >
        <v-icon v-if="!iconT(item.id_sport).custom" left>
          {{ iconT(item.id_sport).src }}
        </v-icon>
        <img
          v-else
          :src="iconT(item.id_sport).src"
          width="24"
          height="24"
          :style="filter"
        />
      </v-list-item-avatar>

      <v-list-item-content v-on:click="pushRoute(item)">
        <v-list-item-title v-text="item.description"> </v-list-item-title>

        <v-list-item-subtitle>
          <div>
            {{ item.scheduled | formatDate }} -
            {{ item.scheduled | formatHour }}
          </div>
        </v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import { icon } from "@/components/icon-sport/icon.js";

export default {
  name: "search",
  data: () => ({
    sigla: "",
    isLoading: false,
    items: [],
    model: null,
    search: null,
    tab: null,
    itemText: "copy_description",
    id_sport: "6046",
  }),
  computed: {
    nameSport() {
      return this.$store.getters.getNameSportById(this.id_sport);
    },
  },
  watch: {
    search(term) {
      if (term == null) return;

      /*
       * Caso o usuário zere a string
       * Reserta o this.items e o this.sigla
       */
      if (term.length == 0) {
        this.items = [];
        this.sigla = "";
      }

      /*
       * Se a string (term) for diferente de 3 ou
       * a sigla for a mesma que ele escreveu antes
       * ele trava o processo buscando o resultado a partir
       * da última busca.
       */
      if (term.length != 3 || term == this.sigla) return;

      /*
       * Faz a busca
       * Primeiro caso: terceiro caracter da string
       * Segundo caso: Se for diferente do que ele escreceu antes, evitando mais uma requisição
       */
      this.isLoading = true;
      this.sigla = term;

      // Registro Event search Analytics
      this.$gtag.search(term);

      // Consumo
      this.$axios
        .post(
          "/tableMain/search",
          this.$formdata({ domain: this.$domain(), term })
        )
        .then((resp) => {
          this.items = resp.data.event;
          this.items.forEach((item) => {
            this.$set(
              item,
              "copy_description",
              this.removerAcentos(item.description)
            );
          });
        })
        .catch(() => {
          this.items = [];
          // const { messages } = error.response.data;
        })
        .finally(() => (this.isLoading = false));
    },
  },

  methods: {
    onFilter(item, queryText) {
      return this.removerAcentos(item.description.toLocaleLowerCase()).includes(
        this.removerAcentos(queryText.toLocaleLowerCase())
      );
    },
    removerAcentos: (newStringComAcento) => {
      let string = newStringComAcento;
      const mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        A: /[\xC0-\xC6]/g,
        e: /[\xE8-\xEB]/g,
        E: /[\xC8-\xCB]/g,
        i: /[\xEC-\xEF]/g,
        I: /[\xCC-\xCF]/g,
        o: /[\xF2-\xF6]/g,
        O: /[\xD2-\xD6]/g,
        u: /[\xF9-\xFC]/g,
        U: /[\xD9-\xDC]/g,
        c: /\xE7/g,
        C: /\xC7/g,
        n: /\xF1/g,
        N: /\xD1/g,
      };

      for (var letra in mapaAcentosHex) {
        var expressaoRegular = mapaAcentosHex[letra];
        string = string.replace(expressaoRegular, letra);
      }

      return string;
    },
    pushRoute: function(item) {
      const listCountry = JSON.parse(sessionStorage.getItem("listCountrys"));
      const listTournaments = JSON.parse(
        sessionStorage.getItem("listTournaments")
      );

      // console.log(item);
      this.id_sport = item.id_sport;

      const {
        id_sport: sport,
        id_category: category,
        tournament_id: tournament,
        id_match: event,
        description,
        live,
      } = item;

      // Registro Event search Analytics
      this.$gtag.search(description);

      const to = {
        name: "eventsTournament",
        params: {
          sport,
          category,
          tournament,
          event,
        },
        query: {
          sport: this.nameSport,
          category: listCountry[category],
          tournament: listTournaments[tournament],
          event: description,
          liveEvent: live == 1 ? true : false,
          mobile: this.$vuetify.breakpoint.smAndDown,
          search: true,
        },
      };

      this.$router.push(to);
    },

    // Implementa o Icon correto por Sport
    iconT: function(id) {
      if (!icon(id)) {
        return {};
      }

      const sportIcon = icon(id);

      if (sportIcon.custom) {
        return { custom: true, src: this.getCustomIcon(sportIcon.src) };
      }

      return { custom: false, src: sportIcon };
    },

    getCustomIcon(fileName) {
      return require("@/assets/icons/" + fileName);
    },
  },

  filters: {
    formatDate: (val) =>
      new Date(val.replace(" ", "T")).toLocaleDateString().slice(0, -5),
    formatHour: (val) =>
      new Date(val.replace(" ", "T")).toLocaleTimeString().slice(0, -3),
  },
};
</script>
